module.exports = __webpack_public_path__ + "static/media/hs_05.a999e1ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_05.jpg
// module id = 5936
// module chunks = 0